"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinAssignmentsComparison = exports.PinAssignmentsRowSchema = void 0;
const z = require("zod");
const signal_name_canonicalization_1 = require("../../DataScience/signal-hygiene/signal-name-canonicalization");
const value_comparison_1 = require("../../Comparison/value-comparison");
const comparison_spec_1 = require("../comparison-spec");
const pin_id_normalization_1 = require("./pin-id-normalization");
exports.PinAssignmentsRowSchema = z.object({
    pinId: z.string(),
    signalName: z.string(),
});
class PinAssignmentsComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new comparison_spec_1.CellAlignment(['pinId'], ['signalName']);
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'pinId' && typeof value === 'string') {
            return (0, pin_id_normalization_1.normalizePinIdForComparison)(value);
        }
        if (column === 'signalName' && typeof value === 'string') {
            return (0, signal_name_canonicalization_1.canonicalizeSignalNameForComparison)(value);
        }
        return super.normalize(column, value, row);
    }
}
exports.PinAssignmentsComparison = PinAssignmentsComparison;
//# sourceMappingURL=pin-assignments.comparison.js.map